import { Center, IconButton, Slider, SliderFilledTrack, SliderThumb, SliderTrack } from "@chakra-ui/react"
import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"


const AudioPlayer: React.FC<{
    audioUrl: string
}> = ({ audioUrl }) => {
    const audioRef = useRef<HTMLAudioElement>(null)
    const [isPaused, setIsPaused] = useState<boolean>(true)
    const [duration, setDuration] = useState<number>(0)
    const [currentTime, setCurrentTime] = useState<number>(0)

    function handleAudioMetaLoad() {
        if(!audioRef.current) return
        setDuration(audioRef.current.duration)
    }

    function togglePlay() {
        if(!audioRef.current) return
        if(isPaused) {
            audioRef.current.play()
        } else {
            audioRef.current.pause()
        }
        setIsPaused(!isPaused)
    }

    useEffect(() => {
        if(audioRef.current && audioRef.current.paused) audioRef.current.currentTime = currentTime
    }, [currentTime])

    return (
        <Center gap={3} w='full'>
            <audio
                ref={audioRef}
                src={audioUrl}
                onEnded={() => setIsPaused(true)}
                onLoadedMetadata={() => handleAudioMetaLoad()}
                onTimeUpdate={() => setCurrentTime(audioRef.current?.currentTime || 0)}
            />
            <IconButton variant='inline' onClick={() => togglePlay()} icon={<FontAwesomeIcon icon={isPaused? faPlay : faPause} />} aria-label="Toggle audio play" />
            <Slider flex={1} value={currentTime} max={duration} onChange={(e) => {
                audioRef.current?.pause()
                setIsPaused(true)
                setCurrentTime(e)
            }}>
                <SliderTrack><SliderFilledTrack /></SliderTrack>
                <SliderThumb />
            </Slider>
        </Center>
    )
}

export default AudioPlayer